import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With nearly two decades of experience, how do you see AI transforming traditional
                risk management models—especially in market and liquidity risk domains?
              </strong>
            </h5>

            <h5 className="text-white">
              Banks are moving fast to adopt AI analytical tools that measure, monitor, and predict
              liquidity and market risk with greater accuracy and speed. The real leap is in
              blending external market data with the bank’s own transactional patterns to run stress
              tests grounded in plausible scenarios drawn from historical regional and global
              events. But here’s the reality: current AI models still lack the maturity to
              incorporate complex decision layers tied to a bank’s unique risk profile, its
              relevance to systemic risk, and its specific risk appetite. Until AI evolves to
              simulate scenarios that truly reflect these factors, it will remain a powerful tool,
              but not yet a full substitute for human judgement.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You are known for challenging conventional risk approaches. What’s one legacy
                practice you believe the industry must rethink urgently, and how should it evolve?
              </strong>
            </h5>
            <h5 className="text-white">
              We need to move away from static, non-actionable risk assessments, dashboards, heat
              maps, and statistics that look impressive but don’t drive decisions. The “three lines
              of defence” is too often used as a shield to deflect ownership rather than a
              collaborative framework. This is where executives must step up, providing the Board
              with early-warning signals and actionable insights, even if they’re messy or
              uncomfortable. Equally, Boards should be asking for that level of candour and
              challenge. Otherwise, we end up with beautifully packaged risk reports that say
              nothing when it matters most.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Given your leadership in AI-driven risk solutions, what are the key success
                factors in integrating AI and data science into enterprise risk frameworks?
              </strong>
            </h5>
            <h5 className="text-white">
              Three things matter most.
              <br />
              <br />
              1) Data readiness: Clean, relevant, and structured data is non-negotiable. AI is only
              as good as the inputs.
              <br />
              2) Domain-context modelling: AI models must be designed with a deep understanding of
              banking risk mechanics; without it, they produce technically clever but operationally
              irrelevant outputs.
              <br />
              3) Governance and model risk controls: AI must sit inside a strong model risk
              management framework, with regular validation, scenario testing, and monitoring for
              drift. AI that ignores governance doesn’t just fail, it creates new systemic risks.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As an international speaker and thought leader, what trends or technologies are
                you most excited about in the future of risk management—and why?
              </strong>
            </h5>
            <h5 className="text-white">
              I’m excited about the convergence of AI, real-time data, and human behaviour
              analytics. The ability to run continuous “what-if” scenarios across risk domains will
              move us from reactive to anticipatory decision-making. But I believe the next real
              frontier is measuring the human side of risk, patterns in decision-making, behavioural
              biases, and cultural signals that precede financial loss. Technology will get us the
              numbers instantly; the real advantage will be in capturing and interpreting the human
              signals behind them.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- In your advisory work with banks and fintechs, how do you help institutions align
                innovation with compliance and long-term risk resilience?
              </strong>
            </h5>
            <h5 className="text-white">
              The first step is to stop treating compliance as a barrier to innovation. It needs to
              be woven into the design process from day one. I encourage institutions to set up
              joint “risk–innovation” squads where product, compliance, and technology work
              together, not in sequence. But there’s also a mindset shift required: zero risk
              tolerance is not a strategy, it’s a stalemate. Meaningful growth comes from thoughtful
              risk-taking, accepting that 20% risk may deliver 80% of the reward. The goal is not to
              avoid risk entirely, but to understand it deeply and take it deliberately.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
